import { Canceler } from 'axios';

/* state */
export interface ICancelerProp {
    key: string;
    canceler: Canceler;
}
export interface AxiosState {
    cancels: {
        [key: string]: Canceler;
    }
}


/* ActionError */
export enum ActionError {
    ERR_VUEX_SETTING = 1,
    ERR_VUEX_DISPATCH,
}
